/** Gera um id estável para o `<input>`; usa `uniqueId` quando informado. */
export function genInputId(type: string, uniqueId?: string) {
  if (uniqueId) return uniqueId;
  return `file-upload-${type}-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

/** Extrai um rótulo curto de formato (ex.: PDF, DOCX) a partir do nome/MIME do arquivo. */
export function formatFileType(file: File) {
  const extension = file.name.split(".").pop()?.toUpperCase();
  if (extension && extension.length < 5) return extension;
  const mimeSub = file.type.split("/")[1];
  if (mimeSub) {
    if (mimeSub.includes("word")) return "DOCX";
    if (mimeSub.includes("sheet") || mimeSub.includes("excel")) return "XLSX";
    if (mimeSub.includes("pdf")) return "PDF";
    return mimeSub.toUpperCase().slice(0, 4);
  }
  return "FILE";
}

/** Formata um tamanho em bytes para a unidade legível mais próxima. */
export function formatBytes(bytes: number, decimals = 2) {
  if (!+bytes) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}
